// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__C9mIJ","fadeInOut":"styles_fadeInOut__azztD","loader":"styles_loader__HDEl_"};